import { render, staticRenderFns } from "./FollowupsMoreFilters.vue?vue&type=template&id=e72f8f02&scoped=true"
import script from "./FollowupsMoreFilters.vue?vue&type=script&lang=js"
export * from "./FollowupsMoreFilters.vue?vue&type=script&lang=js"
import style0 from "./FollowupsMoreFilters.vue?vue&type=style&index=0&id=e72f8f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72f8f02",
  null
  
)

export default component.exports